import React, { Component } from 'react'
import I18n from 'i18n-js';
import '../translations.js';

export default class SummaryTab extends Component {
  constructor(props) {
    super(props);
    this.getRowsFor = this.getRowsFor.bind(this);
    this.calculateTotal = this.calculateTotal.bind(this);
    this.serviceDetails = this.serviceDetails.bind(this);
    this.getQuanitity = this.getQuanitity.bind(this);
  }

  serviceList(category) {
    if (category === "all") {
      return ['stalls_daily', 'stalls_show', 'campsites_daily', 'campsites_show', 'hay', 'bedding', 'paddocks', 'horse_checks'];
    } else {
      return ['stalls_daily', 'campsites_daily', 'hay', 'bedding', 'paddocks', 'horse_checks'];
    }
  }

  getBasePrice(service, cost_type, id) {
    var details = this.props.show[service].filter((element) => element.id === Number(id))[0];
    if (details) {
      return Number(details[cost_type]);
    } else {
      return 0;
    }
  }

  getQuanitity(source) {
    if (this.serviceList("arrays").includes(source)) {
      var service = this.props.summary.services.filter((element) => element.source === this.serviceDetails(source).service);
      return service.map((element) => {return parseInt(element.value)}).filter(Number).reduce((total, x) => {return total + x;}, 0);
    } else {
      return Number(this.props.summary[this.serviceDetails(source).service]);
    }
  }

  serviceDetails(service) {
    switch(service) {
      case "stalls_daily":
        return {service: "stallsDailyReservations", name: I18n.t("rts.services.stalls_daily"), available: true,
                price: this.getBasePrice("stall_types", "daily_cost", this.props.summary.stallsDailyType)};
      case "stalls_show":
        return {service: "stallsShowReservations", name: I18n.t("rts.services.stalls_show"), available: true,
                price: this.getBasePrice("stall_types", "show_cost", this.props.summary.stallsShowType)};
      case "campsites_daily":
        return {service: "campsitesDailyReservations", name: I18n.t("season_stalls.campsites_daily"), available: true,
                price: this.getBasePrice("campsite_types", "daily_cost", this.props.summary.campsitesDailyType)};
      case "campsites_show":
        return {service: "campsitesShowReservations", name: I18n.t("season_stalls.campsites_show"), available: true,
                price: this.getBasePrice("campsite_types", "show_cost", this.props.summary.campsitesShowType)};
      case "hay":
        return {service: "hays", name: I18n.t("rts.services.hay"), price: this.props.show[service].price, available: this.props.show[service].available};
      case "bedding":
        return {service: "beddings", name: I18n.t("rts.services.bedding"), price: this.props.show[service].price, available: this.props.show[service].available};
      case "paddocks":
        return {service: "paddocks", name: I18n.t("rts.services.paddocks"), price: this.props.show[service].price, available: this.props.show[service].available};
      case "horse_checks":
        return {service: "horse_checks", name: I18n.t("rts.services.check"), price: this.props.show[service].price, available: this.props.show[service].available};
    }
  }

  getRowsFor(source, index){
    if (this.serviceDetails(source).available){
      var price = this.serviceDetails(source).price;
      var quantity = this.getQuanitity(source);
      return  <tr key={index}>
                <td>{this.serviceDetails(source).name}</td>
                <td>{quantity}</td>
                <td>{I18n.toCurrency(price)}</td>
                <td>{I18n.toCurrency(price*quantity)}</td>
              </tr>
    } else {
      return undefined;
    }
  }

  calculateTotal(){
    var total = this.props.summary.adjustments;
    this.serviceList("all").forEach( (source) => {
      var price = this.serviceDetails(source).price
      var quantity = this.getQuanitity(source)
      total += quantity*price
    });
    return total;
  }

  render() {
    return (
      <div>
        <table className="table">
          <thead>
            <tr>
              <th>Service</th>
              <th>{I18n.t("rts.services.qty")}</th>
              <th>{I18n.t("activerecord.attributes.services.unit_cost")}</th>
              <th>{I18n.t("activerecord.attributes.services.total_cost")}</th>
            </tr>
          </thead>
          <tbody>
            {this.serviceList("all").map((service, index) =>
              this.getRowsFor(service, index)
              )
            }
            {this.props.summary.adjustments > 0 ?
              <tr>
                <td>{I18n.t("season_stalls.fee_adjustments")}</td>
                <td></td>
                <td></td>
                <td>{I18n.toCurrency(this.props.summary.adjustments)}</td>
              </tr> :
              undefined
            }
          </tbody>
        </table>
        <table className="table">
          <thead>
            <tr>
              <th>{I18n.t("fees.total", {item: ""})}</th>
              <th>{`${I18n.t("activerecord.attributes.services.tax")} (${this.props.show.tax_rate}%)`}</th>
              <th>{I18n.t("fees.total_with_tax")}</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>{I18n.toCurrency(this.calculateTotal())}</td>
              <td>{I18n.toCurrency(this.calculateTotal() * this.props.show.tax_rate/100)}</td>
              <td>{I18n.toCurrency(this.calculateTotal() * (1 + this.props.show.tax_rate/100))}</td>
            </tr>
          </tbody>
        </table>
      </div>
    )
  }
}
